__turbopack_context__.v({
  "avatarWrapper": "QycH6q_avatarWrapper",
  "avatarWrapperActive": "QycH6q_avatarWrapperActive",
  "avatarWrapperHidden": "QycH6q_avatarWrapperHidden",
  "avatarWrapperInactive": "QycH6q_avatarWrapperInactive",
  "avatarWrapperMedium": "QycH6q_avatarWrapperMedium",
  "userAvatar": "QycH6q_userAvatar",
  "userAvatarMedium": "QycH6q_userAvatarMedium",
});
